import { useAtomValue } from "jotai";
import { useMemo } from "react";

import { permissionsAtom } from "@/store/auth";

/**
 * 判断权限码是否在权限列表中（纯函数，供非 Hook 场景复用）
 * @param permissions 权限码列表
 * @param code 待校验权限码，空则视为有权限
 */
export const hasPermission = (permissions: readonly string[], code?: string): boolean => {
  const normalized = code?.trim();
  if (!normalized) return true;
  return permissions.includes(normalized);
};

/**
 * 判断当前用户是否拥有指定权限码
 * @param code 权限码，如 user:delete；不传或空字符串时视为有权限
 */
export const usePermission = (code?: string): boolean => {
  const permissions = useAtomValue(permissionsAtom);
  // Set 便于权限码增多时 O(1) 查找
  const permissionSet = useMemo(() => new Set(permissions), [permissions]);
  const normalized = code?.trim();
  if (!normalized) return true;
  return permissionSet.has(normalized);
};
